module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-academic-year/142/assets/images/fdd7a72443fe785bb72745e86d1c525d.png";